{
    "age_verification": {
        "title": "Welkom!",
        "message": "Ben je {{minAge}} jaar of ouder?",
        "button": "Enter",
        "error_message": "Je moet {{minAge}} jaar of ouder zijn om deze inhoud te bekijken.",
        "button_reset": "Terug"
    },

    "welcome": {
        "title": "Welkom!",
        "description": ""
    },

    "unknown": {
        "title": "Onbekende pagina",
        "description": "De pagina die je probeert te bereiken bestaat niet of is niet beschikbaar."
    },

    "preview": {
        "text": "Dit is een voorbeeldweergave en is maar tijdelijk beschikbaar."
    },

    "cookies": {
        "title": "Cookies",
        "description": "Deze website maakt gebruik van cookies om de gebruikerservaring te verbeteren. Door verder te gaan, ga je akkoord met ons cookiebeleid.",
        "button_accept_all": "Alles toestaan",
        "button_decline_all": "Alles afwijzen",
        "button_show_preferences": "Toon voorkeuren",
        "button_save_preferences": "Voorkeuren opslaan",
        "button_close": "Sluiten",

        "sections": {
            "introduction": {
                "title": "Voorkeurenmenu",
                "description": "Deze website maakt gebruik van cookies om de gebruikerservaring te verbeteren. Cookies zijn kleine tekstbestanden die op je apparaat worden opgeslagen wanneer je onze website bezoekt. Ze helpen ons te begrijpen hoe je onze site gebruikt en stellen ons in staat om de functionaliteit en prestaties te verbeteren."
            },

            "information": {
                "title": "Meer informatie",
                "description": "Voor vragen over ons cookiebeleid en je keuzes, <a href=\"#contact-page\">neem contact met ons op</a>."
            },

            "necessary": {
                "title": "Noodzakelijk",
                "description": "Deze cookies zijn essentieel voor de werking van de website en kunnen niet worden uitgeschakeld in onze systemen. Ze worden meestal alleen ingesteld als reactie op acties die je hebt uitgevoerd, zoals het instellen van je leeftijd ."
            },
            "analytics": {
                "title": "Analytics",
                "description": "Deze cookies helpen ons te begrijpen hoe bezoekers onze website gebruiken door anonieme informatie te verzamelen en rapporten op te stellen. Deze cookies kunnen worden gebruikt om de prestaties van de website te verbeteren en om te begrijpen welke pagina's populair zijn en hoe bezoekers door de site navigeren."
            }
        }
    }
}